import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AgentOnboardingAudience } from './agentOnboardingAnalytics';
import META from './useTrackAgentOnboardingDemoCompleted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentOnboardingDemoCompletedParams = {
  audience: AgentOnboardingAudience;
};

export const useTrackAgentOnboardingDemoCompleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentOnboardingDemoCompleted = useCallback(
    (params: UseTrackAgentOnboardingDemoCompletedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentOnboardingDemoCompleted };
};
